// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-28
import React from 'react';
import { strings } from 'src/localization';
import * as css from './DepartmentContactInfo.module.scss';

interface IProps {
    contactPhone: string;
    extension?: string;
}

// group 1: optional country code, group 2: optional area code, groups 3-4: local number segments
const PHONE_NUMBER_REGEX = /^(1|)?(\d{3})?(\d{3})(\d{4})$/;

/** Renders a formatted phone link with optional extension for department contact info.
 *  Expects contactPhone as a raw digit string (e.g. '8005551234' or '18005551234'). */
export const DepartmentContactInfo = (props: IProps) => {
    const { contactPhone, extension } = props;
    const match = contactPhone.match(PHONE_NUMBER_REGEX);
    const phone = match ? `${match[1] ? match[1] + '-':
        ''}${match[2] ? match[2] + '-' : ''}${match[3]}-${match[4]}` : contactPhone;

    return (
        <>
            {/* target='hidden-iframe' routes the tel: activation to the named iframe in App.tsx, suppressing browser navigation */}
            <a href={'tel:' + contactPhone} className={css.contactInfo} target='hidden-iframe'
                data-testid='dept-contact-phone' aria-label={`Call ${phone}`}>
                {phone}
            </a>
            {extension && <span data-testid='dept-contact-extension'>{` ${strings.ext} ${extension}`}</span>}
            <span>.</span>
        </>
    );
};
